export const STEPS_COEFFICIENT = 7.5;
export const DEPTH_COEFFICIENT = 11;
